var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goto-statistics",class:{ 'goto-statistics--mobile': _vm.isMobile },on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"goto-statistics__text"},[_vm._v("Ver estadísticas")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goto-statistics__icon"},[_c('img',{attrs:{"src":"/icons/icn_statistics.png","alt":""}})])
}]

export { render, staticRenderFns }